import { mapGetters } from 'vuex';
import Toolbar from '@/components/toolbar';
import BottomNav from '@/components/bottom-nav';
import LoadingComponent from '@/components/loading-component';
import ProviderAdd from '../add-by-provider/add-by-provider.vue';
import StudentAdd from '../add-by-student/add-by-student.vue';

export default {
  name: 'AgencyScheduler',
  components: {
    Toolbar,
    BottomNav,
    LoadingComponent,
    ProviderAdd,
    StudentAdd
  },
  data() {
    return {
      addBy: 'PROVIDER',
      showLoading: false
    };
  },
  computed: {
    ...mapGetters({
      showTooltip: 'showTooltip'
    }),
    isMobile() {
      return this.$mq === 'mobile';
    },
    isTablet() {
      return this.$mq === 'tablet';
    },
    isDesktop() {
      return this.$mq === 'laptop' || this.$mq === 'desktop';
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/agency-scheduler/agency-scheduler-container/agency-scheduler-container.js